import { FirebaseData } from "../General/FirebaseData";
import { DeviationData } from "../Deviation/DeviationData";
import { PropertyData } from "../Property/PropertyData";
import { LocalData } from "../General/LocalData";
import { DeviationStatus } from "../Deviation/DeviationStatus";

export class RoutineActivityData extends FirebaseData {
  date?: Date;
  property?: PropertyData;
  deviation?: DeviationData;
  unitID?: string;
  /** @deprecated load status directly instead */
  status: DeviationStatus = DeviationStatus.NOT_STARTED;
  isDeleted: boolean = false;

  setup(data: any) {
    this.date = typeof data.dateStr === "string" ? convertStringToDate(data.dateStr) : undefined;
    this.property = typeof data.propertyID === "string" ? LocalData.properties.addData(data.propertyID) : undefined;
    this.unitID = typeof data.unitID === "string" ? data.unitID : undefined;

    this.deviation = undefined;
    if (typeof data.deviationID === "string") {
      this.deviation = this.property?.deviations.addData(data.deviationID);
      if (typeof data.dateStr === "string" && this.deviation) this.deviation.reportDate = convertStringToDate(data.dateStr);
    }

    this.status = typeof data.status === "number" ? DeviationStatus.getStatusWithId(data.status) : DeviationStatus.NOT_STARTED;

    if (typeof data.deleted === "boolean") this.isDeleted = data.deleted;
  }
}

function convertStringToDate(str: string): Date | undefined {
  const fields = str.split(".");
  const dd = fields[2];
  const mm = fields[1];
  const yyyy = fields[0];
  try {
    if (!isNaN(parseInt(yyyy)) && !isNaN(parseInt(mm)) && !isNaN(parseInt(dd))) {
      const date = new Date();
      date.setUTCFullYear(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
      return date;
    }
  } catch (error) {
    console.error(error);
  }
  return undefined;
}

